import { useCallback } from 'react'
import { useClient } from '@based/sdk/react'
import { type Control, type FieldValues } from 'react-hook-form'
import { useFormWatchAutosave } from '@app/util/hooks/useFormWatchAutosave'

/**
 * Debounced `edit-initiative` from current RHF values; `watchDeps` should list
 * watched fields so the autosave payload is referentially stable when unchanged.
 */
export const useInitiativeFormWatchAutosave = <
  TFieldValues extends FieldValues,
>({
  initiativeId,
  control,
  toPayload,
  watchDeps,
}: {
  initiativeId: number
  control: Control<TFieldValues>
  toPayload: (values: TFieldValues) => Record<string, unknown>
  watchDeps: (values: TFieldValues) => readonly unknown[]
}): void => {
  const client = useClient()
  const save = useCallback(
    (value: Record<string, unknown>) =>
      client.call('edit-initiative', { id: initiativeId, value }),
    [client, initiativeId],
  )

  useFormWatchAutosave({ control, toPayload, watchDeps, save })
}
